export default {
  log: (...params) => console.log(...params),
};
